import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import ErrorBoundaryWithLogging from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging/ErrorBoundaryWithLogging";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { AvailableProvidersPanel } from "../components/AvailableProvidersPanel/AvailableProvidersPanel";
import { ContactsWaterfallErrorView } from "../components/ContactsWaterfallErrorView/ContactsWaterfallErrorView";
import { WaterfallConfigurationPanel } from "../components/WaterfallConfigurationPanel/WaterfallConfigurationPanel";

const ContactsWaterfallPage = () => {
    const { translate } = useTranslate();
    const variant = salesSettingsHelper.isAdmin() ? "admin" : "user";

    return (
        <Stack
            gap="30px"
            data-automation="contacts-waterfall-page"
            margin="0 auto"
            padding="40px"
            height="100vh"
        >
            <Stack flex="0 0 auto">
                <Text
                    fontVariant="h4"
                    color={colorsPalettes.carbon[500]}
                >
                    {translate("si.pages.contacts_waterfall.title")}
                </Text>
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[300]}
                    margin="4px 0 0"
                >
                    {translate("si.pages.contacts_waterfall.description.line1")}
                </Text>
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[300]}
                >
                    {translate("si.pages.contacts_waterfall.description.line2")}
                </Text>
            </Stack>
            <ErrorBoundaryWithLogging FallbackComponent={ContactsWaterfallErrorView}>
                <Flex
                    gap="24px"
                    alignItems="stretch"
                    flex="1 1 auto"
                    overflow="hidden"
                >
                    {variant === "admin" ? <AvailableProvidersPanel /> : null}
                    <WaterfallConfigurationPanel variant={variant} />
                </Flex>
            </ErrorBoundaryWithLogging>
        </Stack>
    );
};

export default ContactsWaterfallPage;
